export class Versions {
    constructor() {}

    public assortmentExcel: string = '1.3.0';
    public changeBufferExcel: string = '1.3.0';
    public bufferTableExcel: string = '1.4.4';
    public marketingPurchase: string = '1.3.6';
    public orders: string = '1.4.36';
    public stocks: string = '1.2.27';
    public itemProperties: string = '1.5.15';
    public chart: string = '1.0.6';
    public supplySchedules: string = '0.5.9';
    public stocksPresetEditor: string = '1.0.0';
    public vacation: string = '1.0.2';
    public manualOrders: string = '1.2.4';
}



// WEBPACK FOOTER //
// ./src/app/shared/models/vesions.ts